/**
 * Track a segment event while checking if library is initialized
 * @param eventName name of event to track
 * @param properties tracking properties for event
 * @returns
 */
export const TrackEvent = (
  eventName: string,
  properties?: Record<string, any>,
) => {
  if (!analytics || !analytics.track) {
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    analytics.track(eventName, properties, () => {
      resolve(true);
    });
  });
};

/**
 * Identify a signup user keyed by the internal user id, carrying the Segment
 * anonymousId so the marketing-site → dashboard identity stitch happens at
 * signup time rather than waiting for the backend's Portal Created identify.
 */
export const IdentifySignup = (traits: {
  userId: string;
  email: string;
  name?: string;
  companyName?: string;
  portalUrl?: string;
}) => {
  if (!analytics || !analytics.identify) return;

  // Inlined to avoid importing StorageUtils (pulls in the store via
  // clients/user reducers, which import AnalyticsUtils.TrackEvent).
  // Matches useAnonymousId's cookie parsing (strip the encoded quote wrapper).
  let rawAnonymousId: string | undefined;
  if (typeof document !== 'undefined') {
    const parts = `; ${document.cookie}`.split('; ajs_anonymous_id=');
    if (parts.length === 2) {
      rawAnonymousId = parts.pop()?.split(';').shift();
    }
  }
  const anonymousId = rawAnonymousId?.replace(/%22/g, '') || '';
  const { userId, ...rest } = traits;
  analytics.identify(userId, rest, {
    integrations: { Amplitude: false }, // match classic onboarding (page.tsx identifyUser)
    ...(anonymousId ? { anonymousId } : {}),
  });
};

export const TrackPartnerStackSignUp = (input: {
  name: string;
  email: string;
  customer_key: string;
  provider_key: string;
}) => {
  if (typeof growsumo === 'undefined' || !growsumo) {
    return;
  }

  growsumo.data = input;
  growsumo.createSignup();
};
